<template >
    <div id="app">
        <div class="content">

            <div class="col-charts">
                <h1 class="title is-4">{{siteName}}</h1>
                <h4>Environment</h4>
                <div class="graph-container height">
                    <plotly-plot :data="environmentData" :config="config" :layout="environmentLayout" v-on:zoom="zoomChange" />
                </div>
            </div>

            <div class="target-graphs">
                <template v-for="graph in graphs" >
                    <div :key="graph.description" class='target-graphs'>
                        <h4>{{graph.description}}</h4>
                        <div class="graph-container"><plotly-plot :data="graph.series" :config="config" :layout="graph.layout" v-on:zoom="zoomChange" /></div>
                    </div>
                </template>

            </div>

            <div style="margin-top: 1rem">
                <div style="padding-top: 3rem">
                <fungicide-blurb/>
                </div>
            </div>
        </div>
    </div>
</template>


<script lang="js">

import FungicideBlurb from "../components/FungicideBlurb.vue";
import PlotlyPlot from "../components/PlotlyPlot.vue";
import Vue from "vue"
import { client } from '@/util';
import { isLoggedIn } from '../client';

export default Vue.extend({
    data() {
        return {
            deployment: null,
            environmentData: [],
            siteName: '',
            LoggedIn: false,
            config: {
                displayLogo: false,
                displayModeBar: false,
            },
            // layout3: {
            //     xaxis: { fixedrange: true, autorange: false}, 
            //     yaxis: { fixedrange: true, side: 'left', title: 'Kilo copies of <br> target DNA'},
            //     showlegend: false,
            //     margin: {"t": 0, "b": 30 },
            //     height: 180,
            //     barmode: "stack"
            //     },
            // layout: {
            //     xaxis: { fixedrange: true, autorange: false}, 
            //     yaxis: { fixedrange: true, side: 'left', title: 'No. Insects <br> Observed'},
            //     showlegend: false,
            //     margin: {"t": 0, "b": 30 },
            //     height: 170,
            //     barmode: "stack"
            //     },
            environmentLayout: {
                xaxis: { fixedrange: true, autorange: false}, 
                yaxis: { fixedrange: true, side: 'left', title: "\u00B0C/mm" },
                yaxis2: { fixedrange: true, side: 'right', title: '%RH', overlaying: "y" },
                showlegend: false,
                margin: {"t": 0, "b": 30 },
                height: 150,
                barmode: "stack"
            },
            targets: [],
            originalRange: [],
            graphs: []
        }
    },
    computed: {
        deploymentId() { return this.$route.params.id },
    },
    created() {
        client.post("/public/deployment/id/" + this.deploymentId).then((result) => {
            this.deployment = result.data.deployment;
            this.siteName = result.data.deployment.site_name;
            //this.layout2.xaxis.range = [this.deployment.start_date, this.deployment.end_date]
            this.environmentLayout.xaxis.range = [this.deployment.start_date, this.deployment.end_date]
            this.originalRange=[this.deployment.start_date, this.deployment.end_date]
                    console.log(this.isPublic);

            this.LoggedIn = isLoggedIn();
            if (this.LoggedIn && this.isPublic !== true){
                this.isPublic = true;
            }

            client.post("/public/graph/deployment/" + this.deploymentId + "/environment").then((result) => {
                this.environmentData = result.data.series;
            });

            this.loadTargets();

        })
    },
    // mounted(){
    // },
    components: {
        FungicideBlurb,
        PlotlyPlot
    },
    methods: {
        async loadTargets() {

            const graphDefinitions = [
                {
                    "description": "Botrytis cinerea",
                    "series": [{
                        "targetId": 30,
                        "name": "a"
                    }]
                },
                {
                    "description": "Botrytis fabae",
                    "series": [{
                        "targetId": 33,
                        "name": "a"
                    }]
                },
                {
                    "description": "Blackleg",
                    "series": [{
                        "targetId": 27,
                        "name": "a"
                    }]
                },
                {
                    "description": "Rust",
                    "series": [{
                        "targetId": 51,
                        "name": "a"
                    }]
                },
                {
                    "description": "Pyrenophora teres f maculata (spot form)",
                    "series": [{
                        "targetId": 26,
                        "name": "a"
                    }]
                },
                {
                    "description": "Pyrenophora teres f teres (net form)",
                    "series": [{
                        "targetId": 25,
                        "name": "a"
                    }]
                },
                {
                    "description": "Sclerotinia sclerotiorum/S. minor",
                    "series": [{
                        "targetId": 29,
                        "name": "a"
                    }]
                },
                {
                    "description": "Zymoseptoria tritici",
                    "series": [{
                        "targetId": 31,
                        "name": "a"
                    }]
                },
                {
                    "description": "Pyrenophora tritici-repentis (YLS)",
                    "series": [{
                        "targetId": 20,
                        "name": "a"
                    }]
                },

                {
                    "description": "Botrytis cinerea Group 9 F-tests",
                    "series": [
                        {
                            "name": "Susceptible",
                            "targetId": 59,
                        },
                        {
                            "name": "Resistant",
                            "targetId": 57,
                        }
                    ]
                },
                { 
                    "description": "Blumeria graminis tritici",
                    "series": [
                        {
                            "name": "Susceptible",
                            "targetId": 60,
                        },
                        {
                            "name": "Resistant",
                            "targetId": 58, 
                        }
                    ]
                }
            ];

            const lastDatesResult = await client.get("/public/deployment/" + this.deploymentId + "/last-result-dates");
            let lastDate = lastDatesResult.data[2]; // 2 is cyclone

            if (lastDate == undefined) {
                lastDate = this.deployment.start_date
            }

            for (let i = 0; i < graphDefinitions.length; i++) 
            {
                const graphDefinition = graphDefinitions[i];

                const graph = {
                    "description": graphDefinition.description,
                    "series": []
                };

                for (let j = 0; j < graphDefinition.series.length; j++) {
                    const seriesDefinition = graphDefinition.series[j];

                    const params = {
                                    "targetId": seriesDefinition.targetId,
                                    "startDate": this.deployment.start_date,
                                    "endDate": this.deployment.end_date,
                                    "sentinelId": this.deployment.sentinel_id
                    }

                    const result = await client.post("/public/graph/pathogen", params);
                    const series = result.data.series[0];
                    series.name = seriesDefinition.name;
                    graph.series.push(series);
                }

                const layout = {
                    xaxis: { fixedrange: true, autorange: false, range: [this.deployment.start_date, this.deployment.end_date]}, 
                    yaxis: { fixedrange: true, side: 'left', title: 'Kilo copies of <br> target DNA'},
                    showlegend: false,
                    margin: {"t": 0, "b": 30 },
                    height: 180,
                    barmode: "stack",
                    shapes: [
                    {
                        type: 'rect',
                        // x-reference is assigned to the x-values
                        xref: 'x',
                        // y-reference is assigned to the plot paper [0,1]
                        yref: 'paper',
                        x0: lastDate,
                        y0: 0,
                        x1: this.deployment.end_date,
                        y1: 1,
                        fillcolor: '#d3d3d3',
                        opacity: 0.2,
                        line: {
                            width: 0
                        }
                    }
                    ]
                };

                graph.layout = layout;

                this.graphs.push(graph);
            }
           },

        zoomChange() {
            this.layout.xaxis.range = this.originalRange
            this.layout = Object.assign({}, this.layout);
        }

    },
})

</script>
<style lang="scss" scoped>

.target-graphs {
    margin-top: 50px;
}

@media only screen and (max-width: 768px) {
    .content {
        margin: 5px;
    }
}

@media only screen and (min-width: 768px) {
    .content {
        margin: 50px 100px 50px 100px;
    }
}
</style>


